import { useEffect, useMemo, useState, } from 'react';
import debounce from 'lodash.debounce';
const BUTTON_WIDTH = 36;
const DEBOUNCE_DELAY = 70;
const useHiddenButtons = (buttonsData, containerRef) => {
    const [hidden, setHidden] = useState({});
    const [shown, setShown] = useState({});
    const allButtons = useMemo(
    // Some `value`s can be null here despite typing!
    () => Object.entries(buttonsData).filter(([key, value]) => key !== '__typename' && value), [buttonsData]);
    const hideableButtons = useMemo(() => allButtons
        .filter((buttonKvp) => buttonKvp[1].canHiding)
        .sort((a, b) => a[1].order - b[1].order), [allButtons]);
    const notHideableButtonsWidth = (buttonsData.collapseToggler ? BUTTON_WIDTH * 2 : BUTTON_WIDTH)
        + BUTTON_WIDTH * (allButtons.length - hideableButtons.length);
    useEffect(() => {
        const container = containerRef.current;
        const ro = new ResizeObserver(debounce((entries) => {
            const { contentRect } = entries[0];
            const buttonsAreaWidth = contentRect.width - notHideableButtonsWidth;
            const buttonsFitNumber = Math.max(0, Math.floor(buttonsAreaWidth / BUTTON_WIDTH));
            setShown(Object.fromEntries(hideableButtons.slice(0, buttonsFitNumber)));
            setHidden(Object.fromEntries(hideableButtons.slice(buttonsFitNumber, hideableButtons.length)));
        }, DEBOUNCE_DELAY));
        if (container) {
            ro.observe(container);
        }
        return () => {
            if (container) {
                ro.unobserve(container);
            }
        };
    }, [containerRef, hideableButtons, notHideableButtonsWidth]);
    return [shown, hidden];
};
export default useHiddenButtons;
